export default __webpack_public_path__ + "static/media/bhi-chart-switch.49026af7.svg";